var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_753_642",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_753_642",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAB1klEQVR4nO3cPW5TQRhG4TNYorDYEg10SKRnBbbkJkuhcXFXQA8NDTRsCbmzJkVyhQMCmzj2fN/MeXpLo/dY13/yBUmSJEmSJEmSJEmSJEn/Mk3TcpqmZetz/I8XrQ/wXB6G/1xr/brdbl+1Ps+pSusDPId5fOAtQK31x36/f7fZbH62Pdlx6QP8Pv4sS4TUAf42/ixDhLQBjo0/ix4h5YvwNE3LWusXjowPUEp5vVgsPl3hWE+SLsD8zC+lvDnxITvg4wWPdJZUl6BTLzsHdrXWm/V6/e2CxzpLmgA9jg9JAvQ6PiQI0PP4EDxA7+ND4AAjjA9BA4wyPgQMMNL4ECzAaONDoAAjjg9BAow6PgQIMPL40DjA6ONDwwCOf69JAMf/5eoBHP+xqwZw/D+l+0WsN16CGvNFuDHfhjbmB7HG/CqiseYBYOwIIQLAuBHCBIAxI4QKAONFCBcAxooQMgCMEyFsABgjQugA0H+E8AGg7wgpAkC/EdIEgD4jpAoA/UVI94vYarXaATe11u8nPmQJ3F7wSGdJFwDuI5RS3gNHn9UPf1P9cIVjPUm6S9Ah/6gdgLcqCMCbdQRwcLual1nG707GGzZJkiRJkiRJkiRJkiRJF3AH9Ny8oV2eRbUAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.1a31c48951f98db19de3f9df523eab08.svg";
export { ForwardRef as ReactComponent };